import {VGLawCookie} from "vglawcookie";

const VGListener = {
	onReady: () => {
		VG.defaults();
		VG.aos();
		VG.ScrollToTop.init($(window));

		// [vegas]
		VG.log();
	},

	onLoad: () => {

	},

	onScroll: ($self) => {
		VG.ScrollToTop.setPosition($self);
	},

	onResize: ($self) => {

	},
};

const VG = {
	log: function (errors = []) {
		if (!errors.length) {
			console.log("%cVG app was initialization","color: green;");
		} else {
			errors.forEach(function (item) {
				console.error(item);
			});
		}
	},

	defaults: () => {
		// Манипуляции с контентом по умолчанию
		$('.vg-page-default, .page-default').each(function () {
			let $self = $(this);

			// Table
			let $table = $self.find('table');
			$table.addClass('table table-hover table-striped');
			$table.wrap('<div class="table-responsive"></div>');

			// image
			$self.find('img').addClass('img-fluid');

			// AOS
			if (enables.scrollAnimation) {
				if (typeof $self.attr('data-aos-start') !== typeof undefined && $self.attr('data-aos-start') !== false) {
					let $tags = ['p', 'li', 'h2', 'h3'],
						start = parseInt($self.data('aos-start')),
						step = 100;

					for (let i = 1; i <= $tags.length; i++) {
						let tag = $tags[i - 1],
							$tag = $self.find(tag);

						if ($tag.length) {
							$.each($tag, function () {
								start = start + step;
								$(this).attr('data-aos', 'fade-up');
								$(this).attr('data-aos-delay', start);
							});
						}
					}

					AOS.init();
				}
			}
		});

		new VGLawCookie({
			enableLinkMore: true,
		});
	},

	aos: () => {
		if (enables.scrollAnimation) {
			AOS.init({once: true});
		}
	},

	ScrollToTop: {
		posActive: 400,
		btn: 'btn-scroll-to-top',

		init: function ($window) {
			let $layoutScrollToTop = $('#' + this.btn);

			if (!$layoutScrollToTop.length) {
				$('body').append('<div class="scroll-top" id="'+ this.btn +'"><span><i class="fal fa-chevron-up"></i></span></div>')

				this.setPosition($window);
			}

			let $btnScrollToTop = $('#' + this.btn + ' span');
			$btnScrollToTop.click(function () {
				window.scrollTo(0, 0);

				return false;
			});
		},

		setPosition: function ($window) {
			let $sticky = $('#' + this.btn ),
				scroll = $window.scrollTop();

			if (scroll >= this.posActive) {
				$sticky.addClass('is-active');
			} else {
				$sticky.removeClass('is-active');
			}
		}
	},
};

export default VGListener;